/**
 * Avatar helpers shared by the DataTable, AvatarGroup, and comment surfaces.
 * Ported verbatim from the CRM app's `lib/utils` so the promoted DataTable
 * keeps identical initials + colour behaviour.
 *
 *   getInitials('Alice Johnson')   → 'AL'
 *   getInitials('alice')           → 'AL'
 *   getInitials('A')               → 'A'
 */
export function getInitials(name: string | null | undefined): string {
  if (!name) return '';
  return name.replace(/\s+/g, '').slice(0, 2).toUpperCase();
}

// 8-colour palette matching the reference design's `--av-0..7`
// (blue / teal / violet / pink / amber / green / red / cyan).
const AVATAR_COLORS = [
  'bg-blue-500',
  'bg-teal-500',
  'bg-violet-500',
  'bg-pink-500',
  'bg-amber-500',
  'bg-green-600',
  'bg-red-500',
  'bg-cyan-700',
] as const;

/**
 * Deterministic avatar background colour derived from initials.
 * Use with `getInitials()`:
 *   const ini = getInitials(user.name);
 *   <AvatarFallback className={cn(getAvatarColor(ini), 'text-white')}>{ini}</AvatarFallback>
 */
export function getAvatarColor(initials: string): string {
  if (!initials) return AVATAR_COLORS[0];
  const index = initials.charCodeAt(0) % AVATAR_COLORS.length;
  return AVATAR_COLORS[index] ?? AVATAR_COLORS[0];
}
